import { useLocalStorage } from "../../../../hooks/useLocalStorage.js";
/* empty css          */
import { fileFromDataUri } from "../../utils/file-from-data-uri.js";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, HTMLSelect } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Files/components/CameraCapture/index.tsx
var constraints = { video: {
	height: {
		ideal: 720,
		max: 1440,
		min: 720
	},
	width: {
		ideal: 1280,
		max: 2560,
		min: 1280
	}
} };
var CameraCapture = ({ onCapture }) => {
	const [capturePreview, setCapturePreview] = useState("");
	const [cameraDeviceOptions, setCameraDeviceOptions] = useLocalStorage("CameraCapture_cameraDeviceOptions", []);
	const [selectedCameraDeviceId, setSelectedCameraDeviceId] = useLocalStorage("CameraCapture_selectedCameraDeviceId", "");
	const canvasRef = useRef(null);
	const videoRef = useRef(null);
	const streamRef = useRef(null);
	const [streamStarted, setStreamStarted] = useState(false);
	const startStream = useCallback((constraints) => {
		navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
			streamRef.current = stream;
			if (videoRef.current) {
				videoRef.current.srcObject = stream;
				videoRef.current.play();
				setStreamStarted(true);
			}
		}).catch((err) => {
			console.error("<CameraCapture /> unable to start stream", err);
		});
	}, []);
	useCallback(() => videoRef.current?.pause(), []);
	useEffect(() => {
		navigator.mediaDevices.enumerateDevices().then((devices) => {
			const options = devices.filter((device) => device.kind === "videoinput").map((videoDevice) => ({
				label: videoDevice.label,
				value: videoDevice.deviceId
			}));
			setCameraDeviceOptions(options);
		}).catch((err) => {
			console.warn(`Error getting media device list`, err);
		});
	}, [streamStarted]);
	useEffect(() => {
		if (selectedCameraDeviceId) {
			const updatedConstraints = {
				...constraints,
				deviceId: { exact: selectedCameraDeviceId }
			};
			startStream(updatedConstraints);
		}
	}, [selectedCameraDeviceId]);
	useEffect(() => {
		if ("mediaDevices" in navigator) startStream({
			...constraints,
			deviceId: { exact: selectedCameraDeviceId }
		});
		return () => {
			if (streamRef.current) {
				streamRef.current.getTracks().forEach(function(track) {
					track.stop();
				});
				if (videoRef.current) videoRef.current.srcObject = null;
			}
		};
	}, []);
	const capture = useCallback(() => {
		if (canvasRef.current && videoRef.current) {
			canvasRef.current.width = videoRef.current?.videoWidth;
			canvasRef.current.height = videoRef.current?.videoHeight;
			canvasRef.current?.getContext("2d")?.drawImage(videoRef.current, 0, 0);
			setCapturePreview(canvasRef.current.toDataURL());
		}
	}, []);
	const handleCaptureSave = useCallback(() => {
		fileFromDataUri(capturePreview, "capture-image").then((file) => {
			onCapture(file);
		}).catch((err) => {
			console.log("fileFromDataUri() err", capturePreview, err);
		});
	}, [capturePreview]);
	return /* @__PURE__ */ jsxs("div", {
		className: "camera-capture-container relative",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "display-cover",
			children: [
				/* @__PURE__ */ jsx("video", {
					autoPlay: true,
					onClick: capture,
					ref: videoRef
				}),
				/* @__PURE__ */ jsx("canvas", {
					ref: canvasRef,
					style: { display: "none" }
				}),
				/* @__PURE__ */ jsx("div", {
					className: "absolute left-0 top-0",
					children: /* @__PURE__ */ jsx(HTMLSelect, {
						onChangeValue: setSelectedCameraDeviceId,
						options: cameraDeviceOptions,
						placeholder: "Select camera",
						value: selectedCameraDeviceId
					})
				})
			]
		}), capturePreview && /* @__PURE__ */ jsxs("div", {
			className: "absolute top-0",
			children: [/* @__PURE__ */ jsx("img", { src: capturePreview }), /* @__PURE__ */ jsx("div", {
				className: "absolute bottom-5 left-5",
				children: /* @__PURE__ */ jsxs("div", {
					className: "gap-x-sm inline-flex",
					children: [/* @__PURE__ */ jsx(Button, {
						onClick: handleCaptureSave,
						size: "lg",
						variant: "main",
						children: "Use Photo"
					}), /* @__PURE__ */ jsx(Button, {
						onClick: () => setCapturePreview(""),
						size: "lg",
						children: "Retake"
					})]
				})
			})]
		})]
	});
};
//#endregion
export { CameraCapture };

//# sourceMappingURL=index.js.map